import { all } from 'redux-saga/effects';

// Cricket Flow
import {
	// Fetch Match Details
	fetchMatchDetails,
	// Initiate Match Payment
	initiateMatchPayment,
} from './CricketFlow';

//PrePaid Flow
import {
	// Add Money
	addMoney,
	// Fetch Txn List
	fetchPrePaidTxnList,
	// Initiate Payment
	initiatePrePaidPayment,
	//Txn Status
	prePaidTxnStatus,
	//Sign Agreement
	signPrePaidAgreement,
} from './PrePaidFlow';

//PostPaid - Received Limit Flow
import {
	//Fetch Bill Details
	fetchBillDetails,
	//Fetch Referred Contact List
	fetchPostPeContactList,
	//Initiate Repayment
	initiateRepayment,
	//Initiate Payment
	initiatePayment,
	//Sign Agreement
	signAgreement,
	//Validate VPA
	validateVpa,
	//Fetch Repayment History
	fetchRepaymentHistory,
} from './PostPaidFlow';

//General Flow
import {
	// Fetch Bank List
	fetchBankList,
	//Fetch KYC Status
	fetchKycStatus,
	//Fetch Pincode Details
	fetchPincodeDetails,
	//Fetch Home Details
	homeDetails,
	// Non Bp Merchant info
	nonBpMerchantInfo,
	//Send Referrals
	sendReferrals,
	//Switch Account Type
	switchAccount,
	//Validate Mobile
	validateMobile,
	// Coach marks shown
} from './General';

//Send Money Flow
import {
	//Fetch Personal Banks
	fetchSendMoneyBankList,
	//Init Bank Details
	initSendMoneyBankDetails,
	//Send Money
	sendMoney,
} from './SendMoneyFlow';

//Transaction Flow
import {
	//Transaction List
	fetchTxnList,
	//Rate Transaction
	rateTransaction,
	//Repayment Status
	repaymentStatus,
	//Transaction Status
	txnStatus,
} from './TransactionFlow';

//Card Flow
import {
	//Fetch Card Details
	fetchCardDetails,
	//Order Card Address
	orderCardAddressDetails,
} from './CardFlow';

//Onboarding Flow
import {
	//Pan Save
	panSave,
	//Init Bank Details
	initBankDetails,
	//Validate Pan
	validatePan,
} from './OnboardingFlow';

export default function* root() {
	yield all([
		homeDetails(),
		validatePan(),
		fetchBankList(),
		panSave(),
		initBankDetails(),
		validateVpa(),
		initiatePayment(),
		txnStatus(),
		fetchTxnList(),
		nonBpMerchantInfo(),
		fetchKycStatus(),
		initiateRepayment(),
		repaymentStatus(),
		fetchBillDetails(),
		fetchCardDetails(),
		orderCardAddressDetails(),
		rateTransaction(),
		fetchPincodeDetails(),
		signAgreement(),
		signPrePaidAgreement(),
		addMoney(),
		prePaidTxnStatus(),
		fetchPrePaidTxnList(),
		initiatePrePaidPayment(),
		switchAccount(),
		sendMoney(),
		validateMobile(),
		fetchSendMoneyBankList(),
		initSendMoneyBankDetails(),
		fetchPostPeContactList(),
		sendReferrals(),
		fetchMatchDetails(),
		initiateMatchPayment(),
		fetchRepaymentHistory(),
	]);
}
